'use client'

import { useSearchParams } from 'next/navigation'

export default function LoadContact({
  children
}: {
  children: React.ReactNode
}) {
  const searchParams = useSearchParams()

  const flowType = searchParams.get('flow')
  if (flowType) {
    sessionStorage.setItem('flowType', flowType)
    sessionStorage.removeItem('contactSecurityToken')
    sessionStorage.setItem('restoreSession', '0')
  }

  const hideDomideal = searchParams.get('partnerDeal')
  if (hideDomideal === '1') {
    sessionStorage.setItem('hideDomideal', '1')
  }

  const securityToken = searchParams.get('token')
  if (securityToken) {
    sessionStorage.setItem('contactSecurityToken', securityToken)
    sessionStorage.setItem('restoreSession', '1')
  }

  const partnerToken = searchParams.get('partner')
  if (partnerToken) {
    sessionStorage.setItem('partnerToken', partnerToken)
  }

  const addressId = searchParams.get('address')
  if (addressId) {
    sessionStorage.setItem('addressId', addressId)
  }

  const cityId = searchParams.get('city')
  if (cityId) {
    sessionStorage.setItem('cityId', cityId)
  }

  const legalStatusId = searchParams.get('legalStatus')
  if (legalStatusId) {
    sessionStorage.setItem('legalStatusId', legalStatusId)
  }

  const promoCode = searchParams.get('promoCode')
  if (promoCode) {
    sessionStorage.setItem('promoCode', promoCode)
  }

  const utmSource = searchParams.get('utm_source')
  if (utmSource) {
    sessionStorage.setItem('utm_source', utmSource)
  }

  const utmMedium = searchParams.get('utm_medium')
  if (utmMedium) {
    sessionStorage.setItem('utm_medium', utmMedium)
  }

  const utmCampaign = searchParams.get('utm_campaign')
  if (utmCampaign) {
    sessionStorage.setItem('utm_campaign', utmCampaign)
  }

  return children
}
